import React, { useState } from 'react';

import WordCloud from 'react-d3-cloud';

const min = 20;
const max = 75;

const WCloud = ({ data, label, color }) => {
  const [tooltip, setTooltip] = useState(null);
  
  const words =
    data && Object.keys(data).length > 0
      ? Object.keys(data).map(word => ({
        text: data[word].word,
        value: data[word].count,
      }))
      : [];
  
  const fontSizeMapper = (word) => {
    if (words.length === 0) {
      return min;
    }
    const minValue = Math.min(...words.map(w => w.value));
    const maxValue = Math.max(...words.map(w => w.value));
    const logValue = Math.log(word.value || 1);
    const logMin = Math.log(minValue || 1);
    const logMax = Math.log(maxValue || 1);
    const normalized = (logValue - logMin) / (logMax - logMin || 1);
    return min + normalized * (max - min);
  };
  
  const onWordMouseOver = (event, d) => {
    setTooltip({
      text: d.text,
      value: d.value,
      x: event.clientX + 10,
      y: event.clientY + 10,
    });
  };
  
  const onWordMouseOut = () => {
    setTooltip(null);
  };
  
  return (
    <div className="flex-1 w-1/2 h-auto min-h-[450px] [&>svg]:!overflow-visible rounded-md bg-white p-8 px-10 shadow-[0px_4px_8px_0px_#0000000D]">
      <div className="border-b-2 border-gray-500">
        <h3>Items: {label}</h3>
      </div>
      
      <div className="relative w-full py-5 px-0 h-[500px] min-h-[500px]">
        {words.length > 0 ? (
          <WordCloud
            width={500}
            height={300}
            data={words}
            font="impact"
            fontStyle="normal"
            fontWeight="600"
            fontSize={fontSizeMapper}
            fill={color}
            rotate={0}
            padding={0}
            spiral="archimedean"
            onWordMouseOver={onWordMouseOver}
            onWordMouseOut={onWordMouseOut}
            random={() => 0.5}
          />
        ) : (
          <div className="flex h-full items-center justify-center text-gray-500">No data available</div>
        )}
        
        {tooltip && (
          <div
            className="pointer-events-none rounded-md bg-gray-800 px-3 py-1.5 text-sm text-white shadow-lg"
            style={{
              position: 'fixed',
              top: tooltip.y,
              left: tooltip.x,
            }}
          >
            {tooltip.text}: <strong>{tooltip.value}</strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default WCloud;
